export default __webpack_public_path__ + "static/Drakez_OfficialLogo-e86e65e57669d5b1ed5b4cb207a335a5.png";